import { useApi } from "shared/services/api/useApi";

export const useTestConnection = () => {
    const { getDataAsync } = useApi();

    const testConnection = async () => {
        try {

            const payload = await getDataAsync("userhealth");
            const rv = await payload.json();

            return "Your user session info: " + JSON.stringify(rv);
            
        } catch (err) {
            return "There is an error to connect to backend. Detail: " + err;
        }
    };

    return { testConnection };
};
